import { render, staticRenderFns } from "./VipRightHeader.vue?vue&type=template&id=15661c0d"
import script from "./VipRightHeader.vue?vue&type=script&lang=js"
export * from "./VipRightHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports